module.exports = __webpack_public_path__ + "static/slider_4-1c9390689fe0dc0dc302cbd5d560ccd4.jpg";